import { TasksTopLevelFilterKey } from '@omnea-app/tasks/tasksFrontendClient'

export const taskQueryKeys = {
  all: ['tasks'] as const,
  list: (filter: TasksTopLevelFilterKey | null) => ['tasks', 'list', filter] as const,
  // Under `list(filter)`, so invalidating a tab's list also invalidates its pages.
  page: (filter: TasksTopLevelFilterKey | null, page: number, pageSize: number) =>
    ['tasks', 'list', filter, 'page', page, pageSize] as const,
  listCount: (filter: TasksTopLevelFilterKey) => ['tasks', 'list', filter, 'count'] as const,
  mineForRequest: (requestId: string) => ['tasks', 'request', requestId, 'mine'] as const,
  allForRequest: (requestId: string) => ['tasks', 'request', requestId, 'all'] as const,
}
